module.exports = __webpack_public_path__ + "static/img/jb_top_img.9c51db1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jb_top_img.png
// module id = KcFv
// module chunks = 1